import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ColorModeContext, tokens } from "../../theme";
import { useTheme, Box, IconButton, InputBase } from "@mui/material";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { useProSidebar } from "react-pro-sidebar";
import {
  logout,
  logoutUser,
  resetAds,
  resetAllBookingsData,
  resetAllFacilitiesData,
  resetAllHighlightsData,
  resetAllRoomsList,
  resetGames,
  resetPublicGroups,
  resetUserCards,
  resetUserDetails,
  resetUserGames,
  resetUserGroups,
} from "../../store/actions";

const Topbar = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const { toggleSidebar, broken, rtl } = useProSidebar();

  const auth = useSelector((state) => state.auth);
  const user = useSelector((state) => state.user);

  const handleLogout = () => {
    if (auth.isLoggedIn) {
      dispatch(resetAllHighlightsData());
      dispatch(resetAllFacilitiesData());
      dispatch(resetAllBookingsData());
      dispatch(resetAllRoomsList());
      dispatch(resetUserGames());
      dispatch(resetUserGroups())
      dispatch(resetAds())
      dispatch(logout());
    } else if (user.isLoggedIn) {
      dispatch(resetGames())
      dispatch(resetUserDetails())
      dispatch(resetPublicGroups())
      dispatch(resetUserCards())
      dispatch(logoutUser());
    }
  };

  return (
    <Box display="flex" justifyContent="space-between" p={2}>
      <Box display="flex">
        {broken && !rtl && (
          <IconButton
            sx={{ margin: "0 6 0 2" }}
            onClick={() => toggleSidebar()}
          >
            <MenuOutlinedIcon />
          </IconButton>
        )}
        <Box
          display="flex"
          backgroundColor={colors.primary[400]}
          p={0.2}
          borderRadius={1}
        >
          <InputBase sx={{ ml: 1, flex: 1 }} placeholder="Search" />
          <IconButton type="button">
            <SearchIcon />
          </IconButton>
        </Box>
      </Box>
      <Box display="flex">
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <LightModeOutlinedIcon />
          ) : (
            <DarkModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton>
          <NotificationsOutlinedIcon />
        </IconButton>
        <IconButton>
          <SettingsOutlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleLogout()}>
          <PersonOutlinedIcon />
        </IconButton>
        {broken && rtl && (
          <IconButton
            sx={{ margin: "0 6 0 2" }}
            onClick={() => toggleSidebar()}
          >
            <MenuOutlinedIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default Topbar;
